module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA1.14dbdc23.jpg";